import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import BuyExtension from "./BuyExtension";
import LangLink from "../../../Localization/LangLink";
import { Txt } from "../../../Routes/Localized";
import { useDialog } from "../../../Providers/Dialog/DialogProvider";
import { fontLink, isArray, useMobile } from "../../../base";
import { FOOTER_COLOR, FOOTER_LINE, FOOTER_LINE_COLOR } from "./base";
import { useLangNavigate } from "../../../Localization/useLangNavigate";
import { useBlog } from "../../../Firebase/BlogProvider";

const getArticleTitle = (title) => {
    if (!title) return;
    const s = String(title).split("|")?.[0];
    if (!s) return title;
    return s.trim();
}

export default function FooterExtension({ buyExtension = true }) {
    const navigate = useLangNavigate();
    const mobile = useMobile();
    const { setDialog } = useDialog();
    const [move, setMove] = useState(null);
    const { getRandomArticles } = useBlog() || {};

    const randomArticles = useMemo(() => {
        if (!getRandomArticles) return [];
        return getRandomArticles(5);
    }, [getRandomArticles]);

    const extendedNavigation = useMemo(() => {
        return [
            {
                title: <Txt id={"23015"} />,
                nav: [
                    {
                        name: <Txt id={"23027"} />,
                        link: "result/sample",
                    },
                    {
                        name: <Txt id={"23032"} />,
                        link: "pricing",
                    },
                    {
                        name: <Txt id={"23035"} />,
                        link: "find_vin",
                    },
                    {
                        name: <Txt id={"10026"} />,
                        link: "cart/coupon",
                        id: ""
                    },
                    {
                        name: <Txt id={"121012"} />,
                        link: "find_report",
                        id: ""
                    },
                ],
            },
            isArray(randomArticles) ? {
                title: <Txt id={"23016"} />,
                nav: randomArticles.map(a => {
                    return {
                        name: getArticleTitle(a.title),
                        link: `article/${a.id}`,
                    }
                })
        /*[
            {
                name: <Txt id={"23028"} />,
                link: "article/3MLPfnuqLI7zLd0m",
            },
            {
                name: <Txt id={"23033"} />,
                link: "",
            },
            {
                name: <Txt id={"23036"} />,
                link: "",
            },
            {
                name: <Txt id={"23040"} />,
                link: "",
            },
            {
                name: <Txt id={"23043"} />,
                link: "",
            },
        ]*/,
            } : false,
            {
                title: <Txt id={"23020"} />,
                nav: [
                    {
                        name: <Txt id={"23025"} />,
                        link: "press",
                    },
                    {
                        name: <Txt id={"23030"} />,
                        link: "",
                    },
                    {
                        name: <Txt id={"23037"} />,
                        link: "student",
                    },
                    {
                        name: <Txt id={"23041"} />,
                        link: "influencer",
                    },
                ],
            }, {
                title: <Txt id={"23021"} />,
                nav: [
                    {
                        name: <Txt id={"23026"} />,
                        link: "about",
                    },
                    {
                        name: <Txt id={"23031"} />,
                        link: "contact",
                    },
                    {
                        name: <Txt id={"23034"} />,
                        link: "press",
                    },
                ],
            },
        ].filter(Boolean);
    }, [randomArticles]);

    return (
        <div>
            <Box sx={{
                minHeight: "410px", bgcolor: FOOTER_COLOR, pt: { xs: "50px", sm: "50px", md: "80px" },
                borderTopLeftRadius: { xs: '0px', sm: '20px', md: '20px' },
                borderTopRightRadius: { xs: '0px', sm: '20px', md: '20px' },
                ...(mobile && { px: '16px' }),
            }}>
                {buyExtension && <BuyExtension />}

                <Container
                    maxWidth="xl"
                    sx={{
                        pb: { xs: "40px", sm: "40px", md: "20px" },
                        pr: "0px !important",
                        pl: { xs: '0px', sm: '0px', md: '0px', lg: '32px', xl: '32px' },
                    }}
                >
                    <Grid
                        container
                        columns={24}
                        sx={{ pl: "20px" }}
                    >
                        {extendedNavigation.map((navData, i) => (
                            <Grid
                                key={"GridItem" + i}
                                xs={24}
                                sm={12}
                                md={6}
                                lg={6}
                                item
                                sx={{}}
                            >
                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                    <Typography
                                        sx={{
                                            textAlign: "left",
                                            fontWeight: 400,
                                            ...fontLink,
                                            color: '#858585',
                                            mb: "30px",
                                            pt: { xs: "60px", sm: "60px", md: "30px" },
                                        }}
                                    >
                                        {navData.title}
                                    </Typography>
                                    {navData.nav.map((nav, j) => (
                                        <Box
                                            key={"NavDataBox" + j}
                                            sx={{ display: "flex", flexDirection: "row", mb: "14px" }}
                                        >
                                            <Box
                                                component={LangLink}
                                                to={nav.link}
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    alignContent: "center",
                                                    width: "100%",
                                                    mr: { xs: "33px", sm: "60px" },
                                                    textDecoration: "none",
                                                }}
                                                onMouseEnter={() => {
                                                    setMove({ i, j });
                                                }}
                                                onMouseLeave={() => {
                                                    if (move?.i === i && move?.j === j) {
                                                        setMove(null);
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    if (nav.link === "" && !nav.id) {
                                                        setDialog("Není prolinkované");
                                                        return;
                                                    }

                                                    const { link, id } = nav;
                                                    if (id) {
                                                        let el = document.getElementById(id);
                                                        if (!el) {
                                                            navigate(link);
                                                            setTimeout(() => {
                                                                el = document.getElementById(id);
                                                                if (el) {
                                                                    el.scrollIntoView({ behavior: "smooth", block: 'start' });
                                                                }

                                                            }, 200)
                                                        } else {
                                                            el.scrollIntoView({ behavior: "smooth", block: 'start' });
                                                        }
                                                    } else if (link) {
                                                        navigate(link);
                                                    }
                                                }}
                                            >
                                                {nav.icon && (
                                                    <div
                                                        style={{
                                                            marginRight: "20px",
                                                            height: "20px",
                                                        }}
                                                    >
                                                        {nav.icon}
                                                    </div>
                                                )}
                                                <Typography
                                                    sx={{
                                                        textAlign: "left",
                                                        fontWeight: 400,
                                                        ...fontLink,
                                                        color: '#fff',
                                                        "&:hover": {
                                                            color: "white",
                                                        },
                                                        width: "fit-content",
                                                        transition: "transform 0.2s ease",
                                                        transform:
                                                            move?.i === i && move?.j === j
                                                                ? "translateX(5px)"
                                                                : "translateX(0px)",
                                                    }}
                                                >
                                                    {nav.name}
                                                </Typography>
                                                <Box sx={{ ml: "auto", pl: "3px" }}>
                                                    <ArrowForwardIosRoundedIcon
                                                        sx={{ maxHeight: "10px", color: '#858585' }}
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
                <Container
                    maxWidth="xl"
                    sx={{

                    }}
                >
                    <Box sx={{ px: { xs: '0px', sm: '0px', md: '0px', lg: '32px', xl: '32px' }, }}>
                        <Box sx={{ ...FOOTER_LINE, mt: '16px' }} />
                    </Box>
                </Container>

            </Box>
        </div>
    );
}
